const WHITE_LIST = [
  'business_email',
  'business_phone_number',
  'include_salary_range',
  'product_type',
];

/**
 *  In order to persist previous formik values after importing a file,
 *  PositionDetailsFormProvider exposes a prop `mergeStrategyOnImport`
 *  to merge those values after the import has completed. (in our case step_1 will be persisted)
 */
export const mergeStrategyOnImport = ({ currentValues, importValues }) => {
  const conservedValues = Object.keys(currentValues)
    .filter((field) => WHITE_LIST.includes(field))
    .reduce((filteredValues, field) => {
      filteredValues[field] = currentValues[field];
      return filteredValues;
    }, {});

  const salaryRangeValue =
    importValues?.salary_range || currentValues?.salary_range;

  const fullRemoteValue = !!importValues?.full_remote;

  return {
    ...importValues,
    ...conservedValues,
    salary_range: salaryRangeValue,
    full_remote: fullRemoteValue,
  };
};
